/**
 * Axios instance voor Wagenpark.
 * - baseURL: REACT_APP_BACKEND_URL + /api
 * - Stuurt de JWT-token + actieve firma mee (multi-firma scoping)
 * - Herstelt automatisch na een verlopen sessie (401)
 */
import axios from "axios";
import { koppelAuthRetry } from "@/lib/authRetry";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("hr_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const firma = localStorage.getItem("hr_firma");
  if (firma) config.headers["X-Firma-Id"] = firma;
  return config;
});

koppelAuthRetry(api);

export default api;
